import React, { useState } from 'react';
import { motion } from 'framer-motion';
import AnimatedSection from '../components/AnimatedSection';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: '',
      });
    }, 3000);
  };

  const contactInfo = [
    {
      icon: 'bi-envelope-fill',
      title: 'Email Us',
      info: 'Send us email',
      link: 'mailto:najebexpress@gmail.com',
      color: 'bg-primary-teal',
    },
    {
      icon: 'bi-telephone-fill',
      title: 'Call Us',
      info: '952-486-3817',
      link: 'tel:952-486-3817',
      color: 'bg-primary-orange',
    },
    {
      icon: 'bi-clock-fill',
      title: 'Business Hours',
      info: 'Mon - Fri: 9:00 AM - 6:00 PM',
      link: null,
      color: 'bg-primary-purple',
    },
  ];

  const services = [
    'Consulting Services',
    'Resource Connections',
    'Job Placement',
    'Tax Services',
    'General Inquiry',
  ];

  return (
    <div className="contact-page mt-5">
      {/* Hero Section */}
      <section className="c-contact-hero position-relative overflow-hidden py-5 py-lg-6" style={{background: 'linear-gradient(135deg, rgba(41, 158, 129, 0.08) 0%, rgba(255, 255, 255, 1) 100%)'}}>
        <div className="position-absolute" style={{bottom: '10%', left: '5%', width: '450px', height: '450px', backgroundImage: 'radial-gradient(circle, rgba(139, 92, 246, 0.06) 0%, transparent 70%)', borderRadius: '50%'}}></div>
        <div className="container-fluid position-relative">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <AnimatedSection className="text-center">
                <div className="c-hero-badge bg-primary-teal bg-opacity-10 text-primary-teal d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4 shadow-sm">
                  <i className="bi bi-chat-dots-fill me-2 fs-5"></i>
                  <span className="fw-bold">Let's Connect</span>
                </div>
                <h1 className="display-3 fw-bold mb-4 text-dark" style={{letterSpacing: '-1px'}}>
                  Get in Touch
                </h1>
                <p className="fs-4 text-muted lh-lg mb-5 mx-auto" style={{maxWidth: '700px'}}>
                  Have questions or ready to get started? We're here to help.
                  Reach out to us and we'll respond as soon as possible.
                </p>
                <div className="c-contact-methods d-flex flex-wrap justify-content-center gap-4 mb-4">
                  <motion.div
                    className="c-method-card bg-white rounded-4 shadow-sm p-4 d-flex align-items-center gap-3 border border-1 border-light"
                    whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
                    transition={{ type: 'spring', stiffness: 300 }}
                    style={{minWidth: '200px'}}
                  >
                    <div className="c-method-icon bg-primary-teal bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                      <i className="bi bi-envelope-fill text-primary-teal fs-5"></i>
                    </div>
                    <div className="text-start">
                      <p className="small text-muted mb-0">Email Us</p>
                      <p className="fw-semibold mb-0 small">Quick Response</p>
                    </div>
                  </motion.div>
                  <motion.div
                    className="c-method-card bg-white rounded-4 shadow-sm p-4 d-flex align-items-center gap-3 border border-1 border-light"
                    whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
                    transition={{ type: 'spring', stiffness: 300 }}
                    style={{minWidth: '200px'}}
                  >
                    <div className="c-method-icon bg-primary-orange bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                      <i className="bi bi-telephone-fill text-primary-orange fs-5"></i>
                    </div>
                    <div className="text-start">
                      <p className="small text-muted mb-0">Call Us</p>
                      <p className="fw-semibold mb-0 small">Immediate Help</p>
                    </div>
                  </motion.div>
                  <motion.div
                    className="c-method-card bg-white rounded-4 shadow-sm p-4 d-flex align-items-center gap-3 border border-1 border-light"
                    whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
                    transition={{ type: 'spring', stiffness: 300 }}
                    style={{minWidth: '200px'}}
                  >
                    <div className="c-method-icon bg-primary-purple bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                      <i className="bi bi-calendar-check-fill text-primary-purple fs-5"></i>
                    </div>
                    <div className="text-start">
                      <p className="small text-muted mb-0">Schedule</p>
                      <p className="fw-semibold mb-0 small">Free Consult</p>
                    </div>
                  </motion.div>
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="contact-info-section section-padding">
        <div className="container">
          <div className="row g-4">
            {contactInfo.map((info, index) => (
              <AnimatedSection className="col-lg-4 col-md-6" key={index} delay={index * 0.1}>
                <motion.div
                  className="contact-info-card"
                  whileHover={{ y: -10 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                >
                  <div className={`contact-icon ${info.color}`}>
                    <i className={info.icon}></i>
                  </div>
                  <h5>{info.title}</h5>
                  {info.link ? (
                    <a href={info.link} className="contact-link">
                    
                       {info.info} 
                    </a>
                  ) : (
                    <p>{info.info}</p>
                  )}
                </motion.div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section section-padding bg-gradient-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <AnimatedSection>
                <div className="contact-form-wrapper">
                  <div className="form-header text-center mb-4">
                    <h2 className="text-white mb-3">Send Us a Message</h2>
                    <p className="text-white-50">
                      Fill out the form below and we'll get back to you within 24 hours
                    </p>
                  </div>

                  {submitted && (
                    <motion.div
                      className="alert alert-success"
                      initial={{ opacity: 0, y: -20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0 }}
                    >
                      <i className="bi bi-check-circle-fill me-2"></i>
                      Thank you for your message! We'll be in touch soon.
                    </motion.div>
                  )}

                  <form onSubmit={handleSubmit} className="contact-form">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="name">
                            <i className="bi bi-person-fill me-2"></i>
                            Full Name *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="John Doe"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="email">
                            <i className="bi bi-envelope-fill me-2"></i>
                            Email Address *
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="john@example.com"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="phone">
                            <i className="bi bi-telephone-fill me-2"></i>
                            Phone Number
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="(555) 123-4567"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="service">
                            <i className="bi bi-briefcase-fill me-2"></i>
                            Service Interested In *
                          </label>
                          <select
                            className="form-control"
                            id="service"
                            name="service"
                            value={formData.service}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select a service...</option>
                            {services.map((service, index) => (
                              <option key={index} value={service}>
                                {service}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-group">
                          <label htmlFor="message">
                            <i className="bi bi-chat-left-text-fill me-2"></i>
                            Your Message *
                          </label>
                          <textarea
                            className="form-control"
                            id="message"
                            name="message"
                            rows="5"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            placeholder="Tell us how we can help you..."
                          ></textarea>
                        </div>
                      </div>

                      <div className="col-12 text-center">
                        <motion.button
                          type="submit"
                          className="btn btn-light btn-lg"
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                        >
                          <i className="bi bi-send-fill me-2"></i>
                          Send Message
                        </motion.button>
                      </div>
                    </div>
                  </form>
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="additional-info section-padding">
        <div className="container">
          <div className="row g-4">
            <AnimatedSection className="col-lg-6">
              <div className="info-box">
                <h3>
                  <i className="bi bi-question-circle-fill text-primary-teal me-2"></i>
                  Frequently Asked Questions
                </h3>
                <div className="faq-list">
                  <div className="faq-item">
                    <h6>Do you charge for consultations?</h6>
                    <p>No, initial consultations are always free.</p>
                  </div>
                  <div className="faq-item">
                    <h6>How quickly will I hear back?</h6>
                    <p>We respond to all inquiries within 24 business hours.</p>
                  </div>
                  <div className="faq-item">
                    <h6>What languages do you support?</h6>
                    <p>We offer services in multiple languages. Contact us to learn more.</p>
                  </div>
                  <div className="faq-item">
                    <h6>Can I schedule a same-day appointment?</h6>
                    <p>Yes, subject to availability. Call us for urgent needs.</p>
                  </div>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection className="col-lg-6" delay={0.2}>
              <div className="info-box">
                <h3>
                  <i className="bi bi-geo-alt-fill text-primary-orange me-2"></i>
                  Visit Us
                </h3>
                <p className="mb-4">
                  While we primarily serve clients remotely and in-home, we're happy to arrange
                  in-person meetings at convenient community locations.
                </p>
                <div className="visit-features">
                  <div className="visit-feature">
                    <i className="bi bi-check-circle-fill text-success"></i>
                    <span>Flexible meeting locations</span>
                  </div>
                  <div className="visit-feature">
                    <i className="bi bi-check-circle-fill text-success"></i>
                    <span>Virtual consultations available</span>
                  </div>
                  <div className="visit-feature">
                    <i className="bi bi-check-circle-fill text-success"></i>
                    <span>Home visits for eligible clients</span>
                  </div>
                  <div className="visit-feature">
                    <i className="bi bi-check-circle-fill text-success"></i>
                    <span>Wheelchair accessible locations</span>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
